import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class BolillaVote extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "matchId", Model.attribute('matchId'));
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "votedScore", Model.attribute('votedScore'));
    _defineProperty(this, "votedKnockoutWinner", Model.attribute('votedKnockoutWinner'));
    _defineProperty(this, "points", Model.attribute('points'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "match", Model.hasOne('match'));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/bolilla-votes' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/BolillaVote', BolillaVote);